import { useLayoutEffect } from "react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "./alert-dialog";

export type ConfirmationOptions = {
  title: string;
  description: string;
  confirmLabel: string;
  destructive?: boolean;
};

export function ConfirmationDialogHost({ options, onResolve }: {
  options: ConfirmationOptions | null;
  onResolve: (confirmed: boolean) => void;
}) {
  // Hiding the host or changing its scope must cancel consent before another click.
  useLayoutEffect(() => () => onResolve(false), [onResolve]);

  return <AlertDialog open={options !== null} onOpenChange={(open) => { if (!open) onResolve(false); }}>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>{options?.title}</AlertDialogTitle>
        <AlertDialogDescription>{options?.description}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel>Cancel</AlertDialogCancel>
        <AlertDialogAction className={options?.destructive ? "bg-destructive text-destructive-foreground hover:bg-destructive/90" : undefined} onClick={() => onResolve(true)}>{options?.confirmLabel}</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>;
}
